import { useContextState } from "../../../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 3,
      '& .MuiTypography-root': {
        fontSize: '14px'
      },
      '& .gp1': {
        gap: 1
      },
      '& .greyClass': {
        color: colors.color13,
      }
    },
    back: {
      marginLeft: '-30px'
    },
    containerBack: {
      width: 'fit-content',
    },
    countAll: {
      display: 'flex',
      alignItems: 'center',
      gap: 1
    },
    circle: {
      width: '25px',
      height: '25px',
      backgroundColor: colors.color1, /* Azul */
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
    },
    footerBtn: {
      marginTop: "20px",
      paddingTop: '0px',
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: '0 20px 20px',
    },
    contentRight: {
      overflowY: 'auto',
      maxHeight: 'calc(90vh - 110px)'
    },
    content: {
      padding: '0 20px',
      paddingTop: '20px',
    },
    pd2: {
      padding: 2,
       height: '100%'
    },
    containerButton :{
      width:'100%',
      display:'flex',
      justifyContent:'flex-end',
      marginTop:2
    },
    mhg: {
      minHeight:'400px'
    }
  }
}

export { useStyles }
